import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { VideoResolutions, VideoType } from "@swo/shared";
import React, { useRef } from "react";
import cn from "classnames";
import { SwarovskiOptikVideoPlayer } from "../../VideoComponent/VideoComponent";

export const VideoHeroImageVisualElement: ReactTFC<{
  desktop: VideoType | undefined;
  mobile: VideoType | undefined;
}> = props => {
  const { desktop, mobile } = props;

  const sharedVideoProps = {
    muted: true,
    playsInline: true,
    autoPlay: true,
    loop: true,
    preload: "auto",
  };

  return (
    <>
      {mobile && (
        <SwarovskiOptikVideoPlayer
          video={mobile.video}
          subtitles={mobile.subtitles}
          sharedVideoProps={sharedVideoProps}
          wrapperClassName={cn("position-absolute", { "visible-mobile": mobile })}
          withPlayerUI={false}
          sys={{ id: "" }}
          portraitMode={false}
          resolutionPickerStrategy={2}
          mode={"fill"}
        />
      )}
      {desktop && (
        <SwarovskiOptikVideoPlayer
          video={desktop.video}
          subtitles={desktop.subtitles}
          sharedVideoProps={sharedVideoProps}
          wrapperClassName={cn("position-absolute", { "visible-desktop": desktop })}
          withPlayerUI={false}
          sys={{ id: "" }}
          portraitMode={false}
          resolutionPickerStrategy={"middle"}
          mode={"fill"}
        />
      )}
    </>
  );
};
